var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEurope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_7429)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_7429",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_7429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47716 15.5228 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20Z",
    fill: "#231D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9942 3.4945L9.99975 2.50012L9.00537 3.4945L9.99975 4.48888L10.9942 3.4945Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67771 4.24111L6.68334 3.2467L5.68896 4.24111L6.68334 5.23549L7.67771 4.24111Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23533 6.68371L4.24096 5.68933L3.24658 6.68371L4.24096 7.67811L5.23533 6.68371Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48925 9.99999L3.49487 9.00562L2.50049 9.99999L3.49487 10.9944L4.48925 9.99999Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2422 13.3286L4.24782 12.3342L3.25342 13.3286L4.24782 14.323L5.2422 13.3286Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.667 15.7511L6.6726 14.7567L5.67822 15.7511L6.6726 16.7455L7.667 15.7511Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3611 16.7455L12.3667 15.7511L13.3611 14.7567L14.3555 15.7511L13.3611 16.7455Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9942 16.5056L9.99975 15.5112L9.00537 16.5056L9.99975 17.5L10.9942 16.5056Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.751 13.3169L15.7566 12.3225L14.7622 13.3169L15.7566 14.3113L16.751 13.3169Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.99999L16.5056 9.00562L15.5112 9.99999L16.5056 10.9944L17.5 9.99999Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7456 6.67333L15.7512 5.67896L14.7568 6.67333L15.7512 7.66774L16.7456 6.67333Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3237 4.24816L13.3293 3.25378L12.335 4.24816L13.3293 5.24257L14.3237 4.24816Z",
    fill: "#FFD400"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_7429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurope);
export default __webpack_public_path__ + "static/media/Europe.7e8023f0f73c72b59a23c5303ef6661b.svg";
export { ForwardRef as ReactComponent };